import {
  FormLabel,
  FormControl,
  Textarea,
  VStack,
} from '@wegroup/design-system';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const WelcomeForm: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  return (
    <VStack align="stretch" spacing="6">
      <Controller
        control={control}
        name="hearAboutUs"
        render={({ field: { onChange, value } }) => (
          <FormControl>
            <FormLabel color="text.gray">
              {t('COMPANY-SCAN_INTRO-TO-OFFICE_HOW-DID-YOU-HEAR-ABOUT-US')}
            </FormLabel>
            <Textarea variant="flows" onChange={onChange} value={value || ''} />
          </FormControl>
        )}
      />
      <Controller
        control={control}
        name="expectanceAsBroker"
        render={({ field: { onChange, value } }) => (
          <FormControl>
            <FormLabel color="text.gray">
              {t('COMPANY-SCAN_INTRO-TO-OFFICE_EXPECT-AS-BROKER')}
            </FormLabel>
            <Textarea variant="flows" onChange={onChange} value={value || ''} />
          </FormControl>
        )}
      />
    </VStack>
  );
};

export default WelcomeForm;
